import React from "react";
import PT from "prop-types";

const MessengerSubTmpl = (props) => {
  return (
    <div
      css={`
        color: var(--font-color-main);
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        min-height: 51px;
        img {
          min-height: 60px;
          margin-inline-end: 10px;
        }
        a,
        button {
          margin-top: 5px;
          display: inline-block;
        }
      `}
    >
      <img width="60" src={props.icon} />
      <div>
        <div>
          {props.isActive ? props.activeStatusText : props.inactiveStatusText}
        </div>
        {props.isActive ? props.UnsubButton : props.SubButton}
      </div>
    </div>
  );
};
MessengerSubTmpl.propTypes = {
  icon: PT.string.isRequired,
  isActive: PT.bool,
  activeStatusText: PT.string.isRequired,
  inactiveStatusText: PT.string.isRequired,
  SubButton: PT.any.isRequired,
  UnsubButton: PT.any.isRequired,
};

export default MessengerSubTmpl;
